import { Typography } from '@mui/material';
import { MprcBarTitle, MprcContainer, MprcFormBarHeader } from 'components';
import { ButtonBack } from 'components/buttons';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { LmsPaths } from 'routes/LmsRouter';
import { TrainingNavigation } from 'views/lms/training/Home/EditTraining';
import { useTrainingManagementContext } from 'views/lms/training/Home/TrainingManagementWrapper';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ListClassroomHeader = () => {
    const { t } = useTranslation("lms");
    const navigate = useNavigate();
    const location = useLocation();
    const tmc = useTrainingManagementContext();
    const lastNav = tmc.editNavigation.length > 0 ? tmc.editNavigation[tmc.editNavigation.length - 1] : null;
    const ls = (location.state ?? {});

    ///
    const goBack = () => {
        if (lastNav) {

            tmc.setEditNavigation(tmc.editNavigation.slice(0, -1));

            navigate(
                LmsPaths.BuildEditTraining(lastNav.trainingId, lastNav.trainingType),
                { state: { to: lastNav } as TrainingNavigation, replace: true }
            );
        }
        else
            navigate(LmsPaths.TrainingList, { replace: true });
    };

    var headerItems = [
        <ButtonBack
            key="btnBack"
            rounded
            variant="outlined"
            color={
                lastNav == null
                    ? undefined
                    : "warning"
            }
            text={
                lastNav == null
                    ? t("Training.Header.ButtonListText")
                    : undefined
            }
            title={
                lastNav
                    ? t("Training.Header.GobackTrainingText", { trainingName: lastNav.name })
                    : t("Training.Header.GobackTrainingListText")}
            sx={{ minWidth: "fit-content" }}
            onClick={goBack}
        />
    ];

    if (ls.trainingName) {
        headerItems.push(
            <Typography
                variant="h4"
                component="div"
                sx={{
                    display: "-webkit-box",
                    "-webkit-line-clamp": "1",
                    "-webkit-box-orient": "vertical",
                    "overflow": "hidden"
                }}>
                {ls.trainingName}
            </Typography>
        );
    }

    headerItems.push(
        <MprcBarTitle key="headerTitle">
            {t("Classroom.List.ManagedClassroomTitle")}
        </MprcBarTitle>
    );

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <MprcContainer>
            <MprcFormBarHeader actions={headerItems} />
        </MprcContainer>
    );
};
